import { stringLookup } from '@/utils/zodHelper';
import { z } from 'zod';

export const translationSchema = z.object({
  id: z.number().optional(),
  language_code: stringLookup().or(z.string()),
  nnc_url: z.string().optional(),
  nnc_support: z.string().optional(),
  inlineIndex: z.number().optional(),
});

export const UpdateSchema = z.object({
  id: z.number().optional(),
  translations: z.array(translationSchema),
});

export type UpdateSchemaType = z.infer<typeof UpdateSchema>;
